import { ArrowRight } from "lucide-react";
import React from "react";

const plans = [
  {
    name: "Loyalty ",
    price: "12",
    description: "For business use only loyalty system.",

    yearly: "120",
    features: [
      { label: "1 card design", included: true },
      { label: "1 location", included: true },
      { label: "unlimited subusers", included: true },
      { label: "card customizations", included: false },
      { label: "scan QR for digital menu", included: false },
      { label: "booking food online", included: false },
      { label: "onlin payment", included: false },
      { label: "order and print at kios", included: false },
    ],
  },
  {
    name: "Ordering ",
    description: "For business use only ordering system.",

    price: "50",
    yearly: "500",
    features: [
      { label: "unlimited subusers", included: true },
      { label: "scan QR for digital menu", included: true },
      { label: "booking food online", included: true },
      { label: "online payment", included: true },
      { label: "order and print at kios", included: true },
      { label: "1 card design", included: false },
      { label: "1 location", included: false },
      { label: "card customizations", included: false },
    ],
  },
  {
    name: "Ultimate",
    description: "For business use full experience",

    price: "60",
    yearly: "600",
    features: [
      { label: "unlimited subusers", included: true },
      { label: "scan QR for digital menu", included: true },
      { label: "booking food online", included: true },
      { label: "online payment", included: true },
      { label: "order and print at kios", included: true },
      { label: "1 card design", included: true },
      { label: "1 location", included: true },
      { label: "card customizations", included: true },
    ],
  },
];

export default function PricingOrderingPlans() {
  return (
    <div className="bg-black ">
      <div className="mx-auto max-w-6xl pt-32 pb-16 text-text">
        <div className="text-center mb-10 ">
          <h2 className="text-3xl font-bold mb-3">Pricing</h2>
          <p className="text-textGray">
            Try any plan. Free for 30 days.
            <br />
            No credit card required. Cancel anytime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-4">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`rounded-2xl p-0 shadow-lg flex flex-col justify-between bg-dry ${
                plan.name === "Ultimate"
                  ? "border-0 border-redlightlight bg-redlightlight text-border"
                  : "border border-border"
              }`}
            >
              <div className="p-6 text-center">
                <div className="text-redlight text-3xl font-bold mb-1">
                  ${plan.price}
                </div>
                <div className="text-sm text-textGray mb-4">per month</div>
                <div className="text-sm text-textGray mb-6">
                  or ${plan.yearly} pay upfront for a year
                </div>

                {plan.name === "Ultimate" ? (
                  <h3 className="text-xl font-semibold mb-2 flex items-center justify-center">
                    <span className="text-redlight">{plan.name}</span>
                    <span className="ml-3 text-[10px] font-semibold text-white bg-redlight px-3 py-1 rounded-full flex items-center">
                      ★ Recommended
                    </span>
                  </h3>
                ) : (
                  <h3 className="text-xl font-semibold mb-2">{plan.name}</h3>
                )}
                <p className="text-sm text-textGray mb-6">{plan.description}</p>
                <button className="bg-redlight text-white py-2 px-6 rounded-full hover:bg-reddard transition flex mx-auto">
                  START FREE TRIAL <ArrowRight className="ml-2" />
                </button>
              </div>

              <div
                className={`border-t p-6  flex-1  ${
                  plan.name === "Ultimate"
                    ? " border-redlight"
                    : " border-border"
                }`}
              >
                <div
                  className={`mb-4 font-semibold  ${
                    plan.name === "Ultimate" ? " text-border" : " border-border"
                  }`}
                >
                  Includes
                </div>
                <ul
                  className={`space-y-3 text-sm  ${
                    plan.name === "Ultimate" ? " text-border" : " text-text"
                  }`}
                >
                  {plan.features.map((feature, fIdx) => (
                    <li
                      key={fIdx}
                      className={
                        feature.included ? "" : "text-textGray line-through"
                      }
                    >
                      {feature.label}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
